/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import InventoryControllerDtoItemGroupListRequest from '../model/InventoryControllerDtoItemGroupListRequest';
import InventoryControllerDtoItemGroupListResponse from '../model/InventoryControllerDtoItemGroupListResponse';
import InventoryControllerDtoItemRemoveRequest from '../model/InventoryControllerDtoItemRemoveRequest';
import InventoryControllerDtoNftInventoryValidUpdateRequest from '../model/InventoryControllerDtoNftInventoryValidUpdateRequest';

/**
* Inventory service.
* @module api/InventoryApi
* @version 1.0
*/
export default class InventoryApi {

    /**
    * Constructs a new InventoryApi. 
    * @alias module:api/InventoryApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiInventoryGetItemGroupListPost operation.
     * @callback module:api/InventoryApi~apiInventoryGetItemGroupListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InventoryControllerDtoItemGroupListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InventoryControllerDtoItemGroupListRequest} [inventoryControllerDtoItemGroupListRequest] 
     * @param {module:api/InventoryApi~apiInventoryGetItemGroupListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InventoryControllerDtoItemGroupListResponse}
     */
    apiInventoryGetItemGroupListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['inventoryControllerDtoItemGroupListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = InventoryControllerDtoItemGroupListResponse;
      return this.apiClient.callApi(
        '/api/Inventory/GetItemGroupList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiInventoryNftInventoryValidUpdatePost operation.
     * @callback module:api/InventoryApi~apiInventoryNftInventoryValidUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InventoryControllerDtoNftInventoryValidUpdateRequest} [inventoryControllerDtoNftInventoryValidUpdateRequest] 
     * @param {module:api/InventoryApi~apiInventoryNftInventoryValidUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiInventoryNftInventoryValidUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['inventoryControllerDtoNftInventoryValidUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Inventory/NftInventoryValidUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiInventoryRemoveItemPost operation.
     * @callback module:api/InventoryApi~apiInventoryRemoveItemPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/InventoryControllerDtoItemRemoveRequest} [inventoryControllerDtoItemRemoveRequest] 
     * @param {module:api/InventoryApi~apiInventoryRemoveItemPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiInventoryRemoveItemPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['inventoryControllerDtoItemRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Inventory/RemoveItem', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
